import React from 'react';
import { useOutlet } from '../../node_modules/react-router-dom/dist/index';
import Menu from '../molecule/menu';
import Footer from '../atom/footer';
function Layout(props) {
    const outlet = useOutlet();
    return (React.createElement("div", { className: "container-sm" },
        React.createElement(Menu, { names: ["O mnie", "Moje projekty"], urls: ['/portfolio/', '/portfolio/projects'] }),
        outlet,
        React.createElement(Footer, null)));
}
export default Layout;
